// Per-user, per-case cache of the Case Chat availability verdict. A plain
// module with no React import so AuthContext can clear it without an import
// cycle. Keyed by the lowercased e-mail AND the case id: a second user on the
// same browser must never be served the previous user's verdict.
import { AVAILABILITY_TTL_MS } from './constants';

interface Entry {
  available: boolean;
  at: number;
}

const cache = new Map<string, Entry>();

const keyOf = (email: string, caseId: string) => `${email.trim().toLowerCase()}:${caseId}`;

/** The cached verdict, or undefined when absent, expired, or there is no signed-in e-mail. */
export function getAvailability(
  email: string | null | undefined,
  caseId: string,
  now: number = Date.now(),
): boolean | undefined {
  if (!email) return undefined;
  const key = keyOf(email, caseId);
  const hit = cache.get(key);
  if (!hit) return undefined;
  if (now - hit.at >= AVAILABILITY_TTL_MS) {
    cache.delete(key);
    return undefined;
  }
  return hit.available;
}

export function setAvailability(
  email: string | null | undefined,
  caseId: string,
  available: boolean,
  now: number = Date.now(),
): void {
  if (!email) return;
  cache.set(keyOf(email, caseId), { available, at: now });
}

export function clearChatAvailabilityCache(): void {
  cache.clear();
}
